var app = angular.module("leonardo");

var WorkOrderValuesFilters = function(
  $scope,
  $controller,
  $rootScope,
  ClientInstanceService,
  WorkOrderPlatformService,
  WorkOrderService
) {

  $controller('FiltersBaseController', {$scope: $scope});

  $scope.updating_platform = false;
  $scope.init = false;

  const clientInstanceOptions = ClientInstanceService.getlist({ essential: true }).then(function (response) {
    return response.map(function (clientInstance) {
      return {
        id: clientInstance.id,
        name: `${clientInstance.name} (id: ${clientInstance.id})`
      };
    });
  });

  WorkOrderPlatformService.getlist({limit: 1}, true).then(function (list){
    $scope.platforms = list.results || list;
    if (!$scope.filterService.hasFilter('pms_platform') && $scope.platforms.length > 0) {
      $scope.filterService.setFilter('pms_platform', $scope.platforms[0].id);
      $rootScope.$broadcast('pms_platform:updated', $scope.platforms[0]);
    }
    WorkOrderService.getPlatformTypes({pms_platform: $scope.platforms[0].id, limit:1}, true).then(function (data) {
      var results = data.results || data;
      if (!$scope.filterService.hasFilter('custom_type') && results.length > 0) {
        $scope.filterService.setFilter('custom_type', results[0].id);
        $rootScope.$broadcast('custom_type:updated', results[0]);
      }
      $scope.filter();
      $scope.init = true;
    }, function (){
      $scope.init = true;
    });
  });

  $scope.filters_options = [
    { group: 'hierarchy',
      name: 'By Hierarchy',
      elements: [
        {
          id: 'client_instances',
          name: 'Client Instance',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          required: false,
          placeholder: 'All Client Instances',
          condition: $scope.authDataService.isAdmin(),
          options: clientInstanceOptions,
          conflicts: ['account_reports', 'property_reports', 'portfolio_reports', 'group_reports', 'managed_by_reports']
        }
      ]
    },
    {
      id: 'search',
      name: 'Name',
      label: null,
      inline: false,
      type: 'text',
      placeholder: 'Name',
      condition: true,
      onSubmit: $scope.filter,
      conflicts: []
    },
    {
      id: 'pms_platform',
      name: 'Platform',
      label: null,
      inline: false,
      type: 'options',
      multiple: false,
      placeholder: 'All Platforms',
      condition: true,
      required: true,
      service: WorkOrderPlatformService,
      conflicts: []
    },
    {
      id: 'custom_type',
      name: 'Custom Type',
      label: null,
      inline: false,
      type: 'options',
      multiple: false,
      placeholder: 'All Types',
      condition: true,
      required: true,
      service: WorkOrderService,
      serviceFunction: WorkOrderService.getPlatformTypes,
      serviceParams: {pms_platform: $scope.filterService.getFilter('pms_platform')},
      conflicts: []
    },
  ];

  var filters = $scope.filterService.hasFilter('filters') ? $scope.filterService.getFilter('filters') : [];

  if (!angular.isArray(filters)) {
    filters = filters.split(',');
  }

  angular.forEach($scope.filterService.filters, function (value, key) {
    if (!_.contains(filters, key)) {
      filters.push(key);
    }
  });

  if (!_.contains(filters, 'pms_platform')) {
    filters.unshift('pms_platform');
  }

  if (!_.contains(filters, 'custom_type')) {
    filters.unshift('custom_type');
  }

  $scope.filterService.setFilter('filters', filters, true);


  $scope.$on('filter-service:filter-changed', function ($event, key, value) {
    if (key === 'pms_platform') {
      $scope.updating_platform = true;
      var changed_filters = angular.copy($scope.filters_options);
      angular.forEach(changed_filters, function(filter){
        if (filter.id === 'custom_type'){
          filter.serviceParams.pms_platform = value;
        }
      });
      $scope.filters_options = changed_filters;
      if ($scope.init) {
        WorkOrderPlatformService.get(value, true).then(function (platform) {
          $rootScope.$broadcast('pms_platform:updated', platform);
        });
        WorkOrderService.getPlatformTypes({
          pms_platform: value,
        }, true).then(function (data){
          var results = data.results || data;
          if (results.length > 0) {
            $scope.filterService.setFilter('custom_type', results[0].id);
            $rootScope.$broadcast('custom_type:updated', results[0]);
          }
          else {
            $scope.filterService.removeFilter('custom_type');
            $rootScope.$broadcast('custom_type:updated', {});
          }
        });
      }
    }
    if (key === 'custom_type') {
      if ($scope.updating_platform) {
        $scope.updating_platform = false;
        return;
      }
      if ($scope.init) {
        WorkOrderService.getPlatformTypes({
          pms_platform: $scope.filterService.getFilter('pms_platform'),
          id:value
        }, true).then(function (data){
          var results = data.results || data;
          $rootScope.$broadcast('custom_type:updated', results.length > 0 ? results[0] : {});
        });
      }
    }
  });

  $scope.$on('filter-service:filter-removed', function ($event, key) {
    if (key === 'pms_platform' && $scope.init) {
      var removed_filters = angular.copy($scope.filters_options);
      angular.forEach(removed_filters, function(filter){
        if (filter.id === 'custom_type'){
          filter.serviceParams.pms_platform = undefined;
        }
      });
      $scope.filters_options = removed_filters;
      $rootScope.$broadcast('pms_platform:updated', {});
    }
    if (key === 'custom_type' && $scope.init) {
      $rootScope.$broadcast('custom_type:updated', {});
    }
  });

};

app.controller('WorkOrderValuesFilters', [
  '$scope',
  '$controller',
  '$rootScope',
  'ClientInstanceService',
  'WorkOrderPlatformService',
  'WorkOrderService',
  WorkOrderValuesFilters
]);